
        export const WEB_API_URL = 'https://gisteco.epsgrau.pe/web';
        export const GRAPHQL_API_URL = 'https://gisteco.epsgrau.pe/web/graphql/main';
        export const PUBLIC_GRAPHQL_API_URL = 'https://gisteco.epsgrau.pe/web/graphql/public';
    